import { render, staticRenderFns } from "./IncomeApplication.vue?vue&type=template&id=00f129fc&scoped=true&"
import script from "./IncomeApplication.vue?vue&type=script&lang=js&"
export * from "./IncomeApplication.vue?vue&type=script&lang=js&"
import style0 from "./IncomeApplication.vue?vue&type=style&index=0&id=00f129fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f129fc",
  null
  
)

export default component.exports